<template>
	<div v-show="shareTipShow" class="sharetips">
		<img src="../assets/img/share-tips02.png" width="280px" style="position:absolute; top:7px; right:27px" />
		<img src="../assets/img/share-tips01.png" width="118px" style="position:absolute; top:60%; left:50%; margin-left:-59px" @click="shareTipsHide" />
	</div>
</template>

<script>
	export default {
		name: 'ShareTips',
		props: {
			shareTipShow: {
				type: Boolean,
				default: false
			},
		},
		data() {
			return {
				
			}
		},
		methods:{
			shareTipsHide(){
				this.$emit('update:shareTipShow', false)
			}
		}
	};
</script>

<style scoped>
.sharetips {
	width: 100%;
	height: 100vh;
	position: fixed;
	left: 0;
	top: 0;
	z-index: 2005;
	background: rgba(0,0,0,0.8);
}
</style>
